import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface BlockRulesTableSkeletonProps {
    rows?: number;
}

export function BlockRulesTableSkeleton({ rows = 8 }: BlockRulesTableSkeletonProps) {
    return (
        <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
            <>
                {Array.from({ length: rows }, (_, index) => (
                    <TableRow key={index}>
                        <TableCell className="w-10">
                            <Skeleton height={16} width={16} />
                        </TableCell>
                        <TableCell>
                            <Skeleton height={16} width={160} />
                        </TableCell>
                        <TableCell className="w-20">
                            <Skeleton height={20} width={48} borderRadius="0.375rem" />
                        </TableCell>
                        <TableCell className="w-24">
                            <Skeleton height={20} width={64} borderRadius="0.375rem" />
                        </TableCell>
                        <TableCell className="w-40">
                            <Skeleton height={16} width={130} />
                        </TableCell>
                        <TableCell className="w-20">
                            <Skeleton height={20} width={56} borderRadius="0.375rem" />
                        </TableCell>
                        <TableCell className="w-36">
                            <Skeleton height={16} width={120} />
                        </TableCell>
                        <TableCell className="w-36">
                            <Skeleton height={20} width={100} borderRadius="0.75rem" />
                        </TableCell>
                        <TableCell className="w-10">
                            <Skeleton height={28} width={28} borderRadius="0.375rem" />
                        </TableCell>
                    </TableRow>
                ))}
            </>
        </SkeletonTheme>
    );
}
